import React from 'react';
import { PropTypes } from 'prop-types';

export const AddIcon = (props) => {
    AddIcon.propTypes = {
        color: PropTypes.string
    };
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={'20'}
            height={'20'}
            viewBox="0 0 45.133 45.133"
            fill={props.color}
            {...props}
        >
            <path
                d="M57.633 38.29H38.29v19.343h-6.447V38.29H12.5v-6.447h19.343V12.5h6.447v19.343h19.343z"
                transform="translate(-12.5 -12.5)"
            />
        </svg>
    );
};
export const CloseIcon = (props) => {
    CloseIcon.propTypes = {
        color: PropTypes.string,
        width: PropTypes.string,
        height: PropTypes.string
    };
    return (
        <svg
            width={props.width || 24}
            height={props.height || 24}
            fill={props.color || '#232733'}
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M7.227 15.712L10.939 12 7.227 8.287a.75.75 0 111.06-1.06L12 10.939l3.712-3.712a.75.75 0 111.06 1.06L13.062 12l3.712 3.712a.75.75 0 11-1.06 1.06L12 13.06l-3.712 3.713a.75.75 0 01-1.061-1.061z"
                fill={props.color || '#232733'}
            />
        </svg>
    );
};

export const EditIcon = (props) => {
    EditIcon.propTypes = {
        color: PropTypes.string,
        disabled: PropTypes.string
    };
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill={props.color || '#416ce1'}
            className={props.disabled && 'disabled'}
            {...props}
        >
            <g id="Group_2258" data-name="Group 2258" transform="translate(3588 -10893)">
                <rect
                    id="Rectangle_4239"
                    data-name="Rectangle 4239"
                    transform="translate(-3588 10893)"
                    opacity="0"
                />
                <path
                    id="Union_10"
                    data-name="Union 10"
                    d="M11.5,18.94a.75.75,0,0,1,0-1.5h7.253a.75.75,0,0,1,0,1.5Zm-9.884,0a.749.749,0,0,1-.731-.577L.064,14.891a2.373,2.373,0,0,1,.461-2.037L9.944,1.073l.007-.009,0,0A3.006,3.006,0,0,1,14.116.653l1.7,1.326.018.014A2.8,2.8,0,0,1,17.1,3.767a2.87,2.87,0,0,1-.368,2.2c-.018.028-.036.055-1.865,2.347a.747.747,0,0,1-.131.164c-1.366,1.712-3.677,4.6-7.59,9.5a2.445,2.445,0,0,1-1.886.914l-3.639.046ZM1.7,13.792a.877.877,0,0,0-.171.755l.68,2.884,3.039-.038a.944.944,0,0,0,.733-.352c1.933-2.418,5.04-6.306,7.178-8.982L8.9,4.788Zm12.4-6.9c.82-1.027,1.36-1.7,1.41-1.769a1.351,1.351,0,0,0,.141-1,1.406,1.406,0,0,0-.652-.887c-.059-.04-1.265-.976-1.779-1.375l-.029-.022a1.512,1.512,0,0,0-.942-.331,1.473,1.473,0,0,0-1.13.519l-1.279,1.6Z"
                    transform="translate(-3586 10896)"
                />
            </g>
        </svg>
    );
};
export const DropDownIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={'#1b1b1b'}
            id="Icon_Menu"
            width={'24'}
            height={'24'}
            viewBox="0 0 24 24"
            {...props}
        >
            <defs>
                <clipPath id="clip-path">
                    <path
                        id="Mask"
                        d="M0 .5A.5.5 0 0 1 .854.147L5.146 4.44a.5.5 0 0 1 0 .707L.854 9.44A.5.5 0 0 1 0 9.087z"
                        className="cls-1"
                        transform="rotate(90 4.794 4.794)"
                    />
                </clipPath>
            </defs>
            <g id="Group_6" transform="translate(7.206 10)">
                <path
                    id="Mask-2"
                    d="M0 .5A.5.5 0 0 1 .854.147L5.146 4.44a.5.5 0 0 1 0 .707L.854 9.44A.5.5 0 0 1 0 9.087z"
                    className="cls-1"
                    transform="rotate(90 4.794 4.794)"
                />
                <g id="Mask_Group_6" clipPath="url(#clip-path)">
                    <path id="Rectangle" d="M0 0H24V24H0z" transform="translate(-7.206 -10)" />
                </g>
            </g>
        </svg>
    );
};
export const TrashIcon = (props) => {
    TrashIcon.propTypes = {
        disabled: PropTypes.bool
    };
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="#ee384e"
            stroke="rgba(0,0,0,0)"
            strokeMiterlimit="10"
            strokeWidth="1"
            className={props.disabled && 'disabled'}
            {...props}
        >
            <g id="Group_2259" data-name="Group 2259" transform="translate(3549 -10893)">
                <rect
                    id="Rectangle_4240"
                    data-name="Rectangle 4240"
                    transform="translate(-3549 10893)"
                    opacity="0"
                />
                <path
                    id="Union_11"
                    data-name="Union 11"
                    d="M5.477,20l-.054-.01a3.474,3.474,0,0,1-2.061-1.238,3.632,3.632,0,0,1-.721-1.929c-.129-1.329-.484-6-.9-12.993H.6a.6.6,0,1,1,0-1.192h5.27V1.794a1.782,1.782,0,0,1,1.4-1.78L7.334,0h3.978A1.637,1.637,0,0,1,12.92,1.337l.01.054V2.638h5.112a.6.6,0,1,1,0,1.192H16.9L16.17,16.591a3.214,3.214,0,0,1-2.718,3.4L13.406,20ZM3.826,16.708A2.465,2.465,0,0,0,4.3,18.014a2.26,2.26,0,0,0,1.292.794H13.31a2.091,2.091,0,0,0,1.275-.782,2.064,2.064,0,0,0,.394-1.382l0-.041L15.708,3.83H2.93C3.326,10.411,3.69,15.3,3.826,16.708ZM7.185,1.391a.6.6,0,0,0-.127.382v.865h4.68V1.515A.457.457,0,0,0,11.6,1.3a.464.464,0,0,0-.293-.109H7.475A.6.6,0,0,0,7.185,1.391ZM11.84,15.036V7.4A.581.581,0,1,1,13,7.4v7.641a.581.581,0,1,1-1.163,0Zm-2.983,0V7.4a.581.581,0,1,1,1.163,0v7.641a.581.581,0,1,1-1.163,0Zm-2.939,0V7.4a.581.581,0,1,1,1.162,0v7.641a.581.581,0,1,1-1.162,0Z"
                    transform="translate(-3546.3 10895)"
                />
            </g>
        </svg>
    );
};
export const CircularCrossIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 10 10"
            fill="#363636"
            {...props}
        >
            <path d="M5 10a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5zm0-4.406l1.783 1.783a.42.42 0 0 0 .638-.542l-.044-.052L5.594 5l1.783-1.783a.42.42 0 0 0-.3-.718.416.416 0 0 0-.245.079l-.052.044L5 4.405 3.217 2.623a.42.42 0 0 0-.639.542l.044.052L4.406 5 2.623 6.783a.42.42 0 0 0 .3.717.418.418 0 0 0 .245-.079l.052-.044L5 5.594z" />
        </svg>
    );
};
export const CrossIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="9.916"
            height="9.916"
            viewBox="0 0 9.916 9.916"
            fill="#363636"
            {...props}
        >
            <g>
                <path d="M9.672.244a.833.833 0 0 1 0 1.179L6.137 4.958l3.535 3.536a.833.833 0 0 1-1.178 1.178L4.958 6.137 1.423 9.672A.833.833 0 0 1 .244 8.494L3.78 4.958.244 1.423A.833.833 0 0 1 1.423.244l3.536 3.535L8.494.244a.833.833 0 0 1 1.178 0z" />
            </g>
        </svg>
    );
};
export const ArrowBottomIcon = (props) => {
    ArrowBottomIcon.propTypes = {
        color: PropTypes.string
    };
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20px"
            height="20px"
            data-name="Component 86 – 39"
            viewBox="0 0 20 20"
            {...props}
        >
            <g data-name="Arrow - Right 2">
                <path
                    fill={props.color || '#989ea3'}
                    stroke={props.color || '#989ea3'}
                    strokeWidth="0.5"
                    d="M4.073 7.173a.592.592 0 01.772-.057l.066.057 5.109 5.109 5.108-5.109a.592.592 0 01.772-.057l.066.057a.592.592 0 01.057.771l-.057.066-5.528 5.528a.592.592 0 01-.771.057l-.067-.057-5.527-5.527a.592.592 0 010-.838z"
                    data-name="Stroke 1"
                ></path>
            </g>
        </svg>
    );
};
export const FileIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <g data-name="vuesax/outline/note">
                <path
                    fill="#416ce1"
                    d="M6.675 18.948a3.6 3.6 0 01-3.947-3.952V6.877c0-2.429 1.143-3.753 3.4-3.929a2.5 2.5 0 012.418-1.9h2.91a2.5 2.5 0 012.418 1.9c2.254.179 3.4 1.5 3.4 3.933V15a3.6 3.6 0 01-3.946 3.948zM3.974 6.877v8.119c0 1.85.855 2.706 2.7 2.706h6.654c1.846 0 2.7-.856 2.7-2.706V6.877c0-1.99-.849-2.573-2.159-2.691a2.506 2.506 0 01-2.158 1.846h-.135l-.048.016H8.546a2.467 2.467 0 01-1.763-.732l-.055-.058-.01-.01a1.833 1.833 0 01-.043-.047l-.008-.013a2.469 2.469 0 01-.533-1c-1.313.11-2.16.701-2.16 2.689zm3.689-2.449a1.231 1.231 0 00.883.366h2.91a1.25 1.25 0 000-2.5h-2.91a1.247 1.247 0 00-.883 2.134zm-.988 10.36a.625.625 0 010-1.25h6.653a.625.625 0 010 1.25zm0-3.33a.625.625 0 010-1.25h3.324a.625.625 0 010 1.25z"
                    data-name="Union 18"
                ></path>
            </g>
        </svg>
    );
};
